import React, { useState, useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Button from 'react-bootstrap/Button';
import { Panel, PanelBody } from '../../../../components/panel/panel';
import DateTime from 'react-datetime';
import InputGroup from 'react-bootstrap/InputGroup';
import CurrencyInput from 'react-currency-input-field';
import moment from 'moment';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import FieldsIncidente from './fieldsIncidente.js';
import './orderStatusCancelar.css';


function OrderStatusCancelar({ formRef, fetchCurrentOrderStatusByOrder, setCurrentOrderStatus, modalInstance, reloadOrderDataFromDB, aseguradora, fechaHoraContacto, fechaHoraReporte }) {
    const { id } = useParams();
    const { Formik } = formik;
    const [tipoCancelaciones, setTipoCancelaciones] = useState([]);
    const [fechaHoraServicioMuertoAutorizado, setServicioMuertoFechaHoraAutorizado] = useState(null);
    const servicioMuertoFechaHoraAutorizado = useRef(null);
    const [textoDiferenciaTiempo, setTextoDiferenciaTiempo] = useState(null);
    const originalOrdenEnCero = useRef(formRef?.values?.orden_en_cero || false);
    const wasCancelled = useRef(false);

    const handleRatingClick = (field, value, setFieldValue) => {
        setFieldValue(field, value);
    };

    const diffDates = (init_date, end_date) => {
        let diferenciaTexto = '';
        if (init_date && end_date) {
            const diff = moment(end_date).diff(moment(init_date));
            const duration = moment.duration(diff);

            const dias = Math.floor(duration.asDays());
            const horas = Math.floor(duration.asHours()) % 24;
            const minutos = Math.floor(duration.asMinutes()) % 60;
            const segundos = Math.floor(duration.asSeconds()) % 60;

            if (dias > 0) {
                diferenciaTexto += `${dias} día${dias !== 1 ? 's' : ''}, `;
            }

            if (horas > 0) {
                diferenciaTexto += `${horas} hora${horas !== 1 ? 's' : ''}, `;
            }

            if (minutos > 0) {
                diferenciaTexto += `${minutos} minuto${minutos !== 1 ? 's' : ''}, `;
            }

            if (segundos > 0) {
                diferenciaTexto += `${segundos} segundo${segundos !== 1 ? 's' : ''}`;
            }

            // Eliminar la coma y el espacio final si existen
            if (diferenciaTexto.endsWith(', ')) {
                diferenciaTexto = diferenciaTexto.slice(0, -2);
            }

        }
        setTextoDiferenciaTiempo(diferenciaTexto);

    }

    useEffect(() => {
        diffDates(fechaHoraContacto, fechaHoraServicioMuertoAutorizado);
    }, [fechaHoraServicioMuertoAutorizado]);

    useEffect(() => {
        axiosClient.get('/cancellationTypes/all').then(response => {

            const formattedOptions = response.data.data.map(cancellationType => ({
                value: cancellationType.id,
                label: cancellationType.cancellation_type,
                cancellation_type_code: cancellationType.cancellation_type_code
            }));
            setTipoCancelaciones(formattedOptions);
        }).catch(error => {
            console.error('Error fetching cancellationTypes:', error);
        });

        // Guardar el valor original de orden_en_cero cuando se monta el componente
        if (formRef?.values?.orden_en_cero !== undefined) {
            originalOrdenEnCero.current = formRef.values.orden_en_cero;
        }
        wasCancelled.current = false;

    }, []);

    // Restaurar el valor original cuando se cierra el modal sin guardar
    useEffect(() => {
        if (modalInstance) {
            const handleModalHidden = () => {
                // Si el modal se cerró sin guardar la cancelación, restaurar el valor original
                if (!wasCancelled.current && formRef && formRef.setFieldValue) {
                    formRef.setFieldValue("orden_en_cero", originalOrdenEnCero.current);
                }
                // Resetear el flag para la próxima vez
                wasCancelled.current = false;
                originalOrdenEnCero.current = formRef?.values?.orden_en_cero || false;
            };

            modalInstance._element.addEventListener('hidden.bs.modal', handleModalHidden);

            return () => {
                if (modalInstance._element) {
                    modalInstance._element.removeEventListener('hidden.bs.modal', handleModalHidden);
                }
            };
        }
    }, [modalInstance, formRef]);

    return (
        <>
            <Formik
                enableReinitialize={true}
                validateOnMount={true}
                validationSchema={yup.object().shape({
                    cancellation_type_id: yup.object().required("Selecciona un motivo de cancelación"),
                    servicio_muerto_persona_autoriza: yup.string(),
                    fecha_hora_contacto: yup.date(),
                    servicio_muerto_fecha_hora_autorizado: yup.date().when(['cancellation_type_id'], ([cancellation_type_id], schema) => {
                        return cancellation_type_id !== null && cancellation_type_id !== undefined && cancellation_type_id.cancellation_type_code === 'SERVICIO_MUERTO' ? schema.required("La fecha de autorización es obligatoria") : schema;
                    }),
                    incident_datetime: yup.date().when(['cancellation_type_id'], ([cancellation_type_id], schema) => {
                        return cancellation_type_id !== null && cancellation_type_id !== undefined && cancellation_type_id.cancellation_type_code === 'INCIDENTE' ? schema.required("La fecha y hora del incidente es obligatoria") : schema;
                    }),
                    //servicio_muerto_fecha_hora_autorizado: yup.date().min(moment(fechaHoraContacto ? fechaHoraContacto : new Date()).add(1, 'second'), 'La fecha y hora de autorización debe ser posterior a la de contacto'),
                    servicio_muerto_monto_penalizacion: yup.number().required("Ingresa un monto igual o superior a 0."),
                    observations: yup.string().required("Las observaciones son obligatorias."),                     
                })}
                initialValues={{
                    cancellation_type_id: '',
                    servicio_muerto_persona_autoriza: '',
                    servicio_muerto_fecha_hora_autorizado: '',
                    servicio_muerto_monto_penalizacion: '',
                    observations: '',
                    incident_description: '',
                    servicio_muerto_fecha_hora_autorizado: '',
                    incident_datetime:'',
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);

                    // Si es ORDEN_EN_CERO, asegurar que orden_en_cero sea true
                    const ordenEnCero = values.cancellation_type_id && values.cancellation_type_id.cancellation_type_code === 'ORDEN_EN_CERO';

                    // Marcar que se guardó la cancelación
                    wasCancelled.current = true;

                    // Actualizar orden_en_cero solo cuando se guarda
                    if (ordenEnCero && formRef && formRef.setFieldValue) {
                        formRef.setFieldValue("orden_en_cero", true);
                    }

                    axiosClient.put(`/orders/updateCurrentOrderStatus/${id}`, {
                        order_status_code: (values.servicio_muerto_monto_penalizacion > 0 || formRef?.values?.totalPendingToPay < 0 || formRef?.values?.totalPendingToPay > 0) ? 'CANCELADO_PAGO_PENDIENTE' : 'CANCELADO',
                        ...values,
                        orden_en_cero: ordenEnCero ? true : (formRef?.values?.orden_en_cero || false)
                    }).then(async response => {
                        Swal.fire({
                            title: 'Orden cancelada',
                            text: 'La orden se ha cancelado.',
                            icon: 'success',
                            confirmButtonText: 'Cerrar',
                            cancelButtonText: 'Cancelar',
                            showCancelButton: false,
                        });

                        const result = await fetchCurrentOrderStatusByOrder();
                        setCurrentOrderStatus(result);
                        console.table("setCurrentOrderStatus", result);

                        if (modalInstance) {
                            modalInstance.hide();
                        }
                        reloadOrderDataFromDB();

                    }).catch(err => {
                       // console.log(err.response);
                        Swal.fire({
                            title: 'Ups!',
                            text: 'Ha ocurrido un error',
                            icon: 'error',
                            confirmButtonText: 'Cerrar',
                            cancelButtonText: 'Cancelar',
                            showCancelButton: false,
                        });

                    });
                }}

            >

                {({ handleSubmit, handleChange, handleBlur, values, touched, errors, setFieldValue, setFieldTouched, validateField }) => (
                    <div className="order-cancel-modal">
                        <div className="order-cancel-modal-header">
                            <div className="d-flex align-items-center gap-3">
                                <div className="order-cancel-header-icon">
                                    <i className="fa fa-exclamation-triangle"></i>
                                </div>
                                <div>
                                    <h5 className="order-cancel-modal-title mb-0">
                                        Cancelación del servicio
                                    </h5>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="order-cancel-modal-body">
                            <Form onSubmit={handleSubmit}>

                                {fechaHoraReporte && (
                                    <div className={`order-cancel-alert mb-3 ${formRef?.values?.totalPendingToPay > 0 ? 'alert-danger' : (
                                        formRef?.values?.totalPendingToPay < 0 ? 'alert-warning' : 'alert-primary'
                                    )}`}>
                                        <div className="d-flex align-items-start">
                                            <div className="order-cancel-alert-icon">
                                                {formRef?.values?.totalPendingToPay > 0 ? <i className="fa-solid fa-face-frown-open"></i> : (
                                                    formRef?.values?.totalPendingToPay < 0 ? <i className="fa-solid fa-sack-dollar"></i> : <i className="fa-solid fa-face-smile-wink"></i>
                                                )}
                                            </div>
                                            <div className="flex-grow-1">
                                                <h6 className="mb-2" style={{ fontSize: '0.95rem', fontWeight: '700' }}>
                                                    {formRef?.values?.totalPendingToPay > 0 ? 'Orden con adeudo' : (
                                                        formRef?.values?.totalPendingToPay < 0 ? 'Orden con Saldo a Favor' : 'Orden sin adeudos'
                                                    )}
                                                </h6>
                                                <Form.Group className="mb-2">
                                                    <Form.Label className="order-cancel-form-label">
                                                        {formRef?.values?.totalPendingToPay > 0 ? 'La Orden presenta un adeudo de: ' : (
                                                            formRef?.values?.totalPendingToPay < 0 ? 'La Orden tiene un saldo a favor de' : 'La orden no tiene adeudos.'
                                                        )}
                                                    </Form.Label>
                                                    {formRef?.values?.totalPendingToPay && formRef?.values?.totalPendingToPay !== 0 && (
                                                        <InputGroup>
                                                            <InputGroup.Text>$</InputGroup.Text>
                                                            <CurrencyInput
                                                                name="formRef?.values?.totalPendingToPay"
                                                                autoComplete='off'
                                                                className="form-control"
                                                                prefix=""
                                                                allowNegativeValue={false}
                                                                decimalsLimit={2}
                                                                decimalScale={2}
                                                                decimalSeparator="."
                                                                groupSeparator=","
                                                                value={formRef?.values?.totalPendingToPay}
                                                                disabled={true}
                                                            />
                                                        </InputGroup>
                                                    )}
                                                    {formRef?.values?.totalPendingToPay > 0 && (
                                                        <small className="text-muted d-block mt-2">
                                                            La Orden se cancelará con el estatus Cancelado (pago pendiente)
                                                        </small>
                                                    )}
                                                    {formRef?.values?.totalPendingToPay < 0 && (
                                                        <small className="text-muted d-block mt-2">
                                                            La Orden se cancelará con el estatus Cancelado (pago pendiente)
                                                        </small>
                                                    )}
                                                </Form.Group>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="order-cancel-section">
                                    <h6 className="order-cancel-section-title">
                                        <i className="fa fa-list-alt me-2"></i>
                                        Motivo de Cancelación
                                    </h6>
                                    <div className="order-cancel-reason-grid">
                                        {tipoCancelaciones.map((option) => {
                                            const isSelected = values.cancellation_type_id && values.cancellation_type_id.value === option.value;
                                            return (
                                                <button
                                                    key={option.value}
                                                    type="button"
                                                    className={`order-cancel-reason-btn ${isSelected ? 'selected' : ''}`}
                                                    onClick={async () => {
                                                        setFieldTouched("cancellation_type_id", true);
                                                        setFieldValue("insurance_id", '');
                                                        const selectedOption = isSelected ? null : option;
                                                        await setFieldValue("cancellation_type_id", selectedOption ? selectedOption : '');
                                                        // Validar el campo inmediatamente después de establecer el valor
                                                        await validateField("cancellation_type_id");
                                                        // Si se selecciona ORDEN_EN_CERO, setear el monto a 0
                                                        // NO actualizar formRef aquí, solo se actualizará al guardar
                                                        if (selectedOption && selectedOption.cancellation_type_code === 'ORDEN_EN_CERO') {
                                                            setFieldValue("servicio_muerto_monto_penalizacion", 0);
                                                        } else if (selectedOption) {
                                                            // Si se selecciona otro motivo, borrar el monto para obligar al usuario a ingresarlo
                                                            setFieldValue("servicio_muerto_monto_penalizacion", '');
                                                        }
                                                    }}
                                                >
                                                    {option.label}
                                                </button>
                                            );
                                        })}
                                    </div>
                                    {touched.cancellation_type_id && errors.cancellation_type_id && (
                                        <div className="text-danger mt-2" style={{ fontSize: '0.875rem' }}>
                                            {errors.cancellation_type_id}
                                        </div>
                                    )}
                                </div>


                                {values.cancellation_type_id && values.cancellation_type_id.cancellation_type_code === 'SERVICIO_MUERTO' && (
                                    <div className="order-cancel-section">
                                        <h6 className="order-cancel-section-title">
                                            <i className="fa fa-calendar me-2"></i>
                                            Información de Servicio Muerto
                                        </h6>
                                        {fechaHoraContacto && (
                                            <Row className='mb-3'>
                                                <Form.Group as={Col} md="12" >
                                                    <Form.Label className="order-cancel-form-label">Fecha y hora de contacto</Form.Label>
                                                    <DateTime
                                                        name='fecha_hora_contacto'
                                                        inputProps={{
                                                            placeholder: 'Fecha y hora de contacto',
                                                            disabled: true,
                                                            className: 'order-cancel-form-control'
                                                        }}
                                                        closeOnSelect={false}
                                                        locale="es"
                                                        value={fechaHoraContacto}
                                                        dateFormat="dddd DD/MMMM/YYYY"
                                                        timeFormat="hh:mm A"
                                                        initialViewMode="days"
                                                        onChange={(e) => {
                                                            setFieldValue("fecha_hora_contacto", e ? e : '');
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Row>
                                        )}




                                        <Row className={`mb-${textoDiferenciaTiempo ? '2' : '3'}`}>
                                            <Form.Group as={Col} md="12" >
                                                <Form.Label className="order-cancel-form-label">Fecha y hora de autorización de la cancelación del Servicio Muerto {aseguradora ? `por ${aseguradora.label}` : ''}</Form.Label>
                                                <DateTime
                                                    name="servicio_muerto_fecha_hora_autorizado"
                                                    ref={servicioMuertoFechaHoraAutorizado}
                                                    inputProps={{ 
                                                        placeholder: 'Fecha y hora de autorización', 
                                                        readOnly: true,
                                                        className: `order-cancel-form-control ${errors.servicio_muerto_fecha_hora_autorizado ? 'is-invalid' : ''}`
                                                    }}
                                                    closeOnSelect={false}
                                                    locale="es"
                                                    value={values.servicio_muerto_fecha_hora_autorizado || ''}
                                                    dateFormat="dddd DD/MMMM/YYYY"
                                                    timeFormat="hh:mm A"
                                                    initialViewMode="days"
                                                    onOpen={(e) => {
                                                        servicioMuertoFechaHoraAutorizado.current.navigate('days');
                                                        setFieldTouched('servicio_muerto_fecha_hora_autorizado', true);
                                                    }}
                                                    onChange={(e) => {
                                                        setFieldValue("servicio_muerto_fecha_hora_autorizado", e ? e : '');
                                                        setServicioMuertoFechaHoraAutorizado(e ? e : null);
                                                    }}
                                                    isInvalid={touched.servicio_muerto_fecha_hora_autorizado && !!errors.servicio_muerto_fecha_hora_autorizado}
                                                />
                                                {touched.servicio_muerto_fecha_hora_autorizado && errors.servicio_muerto_fecha_hora_autorizado && (
                                                    <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                                        {errors.servicio_muerto_fecha_hora_autorizado}
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Row>
                                        {textoDiferenciaTiempo && (
                                            <div className="alert alert-primary fade show mb-3">
                                                <i className="fa fa-clock-o me-2"></i>
                                                Tiempo transcurrido entre la hora de contacto y la autorización de la cancelación: <strong>{textoDiferenciaTiempo}</strong>
                                            </div>
                                        )}



                                        <Row className="mb-3">
                                            <Form.Group as={Col} md="12" >
                                                <Form.Label className="order-cancel-form-label">Nombre de la persona que brinda Autorización {aseguradora ? `(aseguradora ${aseguradora.label})` : ''}</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="servicio_muerto_persona_autoriza"
                                                    placeholder="Nombre de quien autoriza"
                                                    value={values.servicio_muerto_persona_autoriza}
                                                    onChange={handleChange}
                                                    className="order-cancel-form-control"
                                                    isInvalid={!!errors.servicio_muerto_persona_autoriza}
                                                    autoComplete="off"
                                                />
                                                {errors.servicio_muerto_persona_autoriza && (
                                                    <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                                        {errors.servicio_muerto_persona_autoriza}
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Row>
                                    </div>
                                )}

                                {values.cancellation_type_id && values.cancellation_type_id.cancellation_type_code === 'INCIDENTE' && (
                                    <FieldsIncidente
                                        errors={errors}
                                        values={values}
                                        touched={touched}
                                        setFieldValue={setFieldValue}
                                        setFieldTouched={setFieldTouched}
                                    />
                                )}

                                <div className="order-cancel-section">
                                    <h6 className="order-cancel-section-title">
                                        <i className="fa fa-dollar-sign me-2"></i>
                                        Monto de Penalización
                                    </h6>
                                    <Row>
                                        <Form.Group as={Col} md='12' >
                                            <Form.Label className="order-cancel-form-label">Monto de penalización a cobrar (cargo adicional a lo ya adeudado)</Form.Label>
                                            <InputGroup className={values.cancellation_type_id && values.cancellation_type_id.cancellation_type_code === 'ORDEN_EN_CERO' ? 'order-cancel-input-disabled' : ''}>
                                                <InputGroup.Text 
                                                    className={values.cancellation_type_id && values.cancellation_type_id.cancellation_type_code === 'ORDEN_EN_CERO' ? 'order-cancel-input-group-disabled' : ''}
                                                >
                                                    $
                                                </InputGroup.Text>
                                                <CurrencyInput
                                                    className={`order-cancel-form-control ${errors.servicio_muerto_monto_penalizacion ? 'is-invalid' : ''}`}
                                                    prefix=""
                                                    allowNegativeValue={false}
                                                    decimalsLimit={2}
                                                    decimalScale={2}
                                                    decimalSeparator="."
                                                    groupSeparator=","
                                                    name="servicio_muerto_monto_penalizacion"
                                                    value={values.servicio_muerto_monto_penalizacion}
                                                    onValueChange={(value) => setFieldValue('servicio_muerto_monto_penalizacion', value)}
                                                    autoComplete='off'
                                                    disabled={values.cancellation_type_id && values.cancellation_type_id.cancellation_type_code === 'ORDEN_EN_CERO'}
                                                />
                                            </InputGroup>
                                            {errors.servicio_muerto_monto_penalizacion && (
                                                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                                    {errors.servicio_muerto_monto_penalizacion}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Row>
                                </div>

                                {values.cancellation_type_id && (
                                    <div className="order-cancel-section">
                                        <h6 className="order-cancel-section-title">
                                            <i className="fa fa-comment me-2"></i>
                                            Observaciones
                                        </h6>
                                        <Form.Group className="w-100">
                                            <Form.Label className="order-cancel-form-label d-block w-100 mb-2">
                                                Observaciones de la Cancelación
                                            </Form.Label>
                                            <textarea
                                                name="observations"
                                                className={`order-cancel-textarea w-100 ${errors.observations ? 'is-invalid' : ''}`}
                                                onChange={(e) => {
                                                    setFieldValue('observations', e.target.value);
                                                }}
                                                value={values.observations}
                                                placeholder="Ingresa las observaciones de la cancelación..."
                                                rows={4}
                                                style={{ width: '100%' }}
                                            ></textarea>
                                            {errors.observations && (
                                                <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                                                    {errors.observations}
                                                </div>
                                            )}
                                        </Form.Group>
                                    </div>
                                )}



                            </Form>

                        </div>
                        <div className="order-cancel-modal-footer">
                            <Button 
                                type="button" 
                                data-bs-dismiss="modal" 
                                className="order-cancel-btn order-cancel-btn-close"
                            >
                                <i className="fa fa-times me-2"></i>
                                Cerrar
                            </Button>
                            <Button 
                                type="button" 
                                className="order-cancel-btn order-cancel-btn-danger" 
                                onClick={handleSubmit} 
                                disabled={Object.keys(errors).length > 0}
                            >
                                <i className="fa fa-ban me-2"></i>
                                Cancelar orden
                            </Button>
                        </div>
                    </div>
                )
                }
            </Formik >


        </>
    );
}

export default OrderStatusCancelar;